import api from '@/API';

export function markAsRead(userNotificationId: number): Promise<void> {
  return api.put(`user-notifications/${userNotificationId}`);
}

export function markAllRead(userId: number): Promise<void> {
  return api.put(`users/${userId}/notifications`);
}
